
<template>
  <div class="">
    <div class="myhistor-cont" v-loading="loading">
      <el-timeline v-if="isdata">
        <el-timeline-item v-for="(item,i) in timeList" :timestamp="item.time" v-if="item.list.length>0" placement="top" :key="t">
          <div v-for="k in item.list" class="myhistorEvery">
            <div class="myhistorEvery-img"><img :src="wjSrc+k.img" /></div>
            <div class="myhistorEvery-nr">
              <div class="disFlex">
                <div class="histor-eve-tit">{{k.cname}}【{{k.productname}}】</div>
              </div>
              <div class="histor-eve-yxq">总课时：{{k.allTime}} | 开始学习时间：{{k.createTime}}
              </div>
              <div class="histor-eve-progress disFlex">
                <div>观看至 {{k.studyTime}} </div>
                <div class="histor-bot-span2" v-if="new Date(k.endtime)>=new Date()" @click="toProduct(k.productid)">继续学习 ></div>
                <div class="histor-bot-span2" v-else>已到期 ></div>
              </div>
            </div>
            <div style="height: 121px;text-align: right;width: 120px;">
              <span style="color: #9a9a9a;font-size: 14px;cursor: pointer;" @click="delLsjl(k.id)"><i class="el-icon-delete"
                  style="padding-right: 5px;"></i>删除</span>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
      <div v-else style="height: 200px;background-color: #fff;text-align: center;">
        <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getTimer,
    format
  } from '../../assets/js/common.js'
  export default {
    name: 'Muhistor',
    props:['wjSrc'],
    data() {
      return {
        timeList: [{
          time: '',
          list: []
        }, {
          time: '三天前',
          list: []
        }, {
          time: '一周前',
          list: []
        }, {
          time: '一个月前',
          list: []
        }],
        tableData: [],
        loading: true,
        isdata:false
      }
    },
    methods: {
      getList: function(id) {
        this.loading = true;
        this.$axios.get('/kt/ktProductAppy/getlearnlistall.htm').then(res => {
          var data = res.data;
          if(data.length>0){
            this.isdata=true;
          }
          var today = format('YYYY-MM-DD hh:mm:ss');
          var timeList = [{
            time: '',
            list: []
          }, {
            time: '三天前',
            list: []
          }, {
            time: '一周前',
            list: []
          }, {
            time: '一个月前',
            list: []
          }];
          data.map((item) => {
            // 三天前的记录
            var days = getTimer(item.modifyTime, today).days; //时间差
            if (days > 3 && days < 7) {
              timeList[1].list.push(item)
            }else if (days >= 7 && days < 31) {
              timeList[2].list.push(item)
            }else if (days >=31) {
              timeList[3].list.push(item)
            }else if (days <=3) {
              timeList[0].list.push(item)
            }
          })
          this.timeList = timeList;
          this.loading = false;
        })
      },
      // 跳转产品详情
      toProduct: function(id) {
        this.$router.push('/ProductDetail?id=' + id);
      },
      // 删除历史记录
      delLsjl: function(id) {
        var $this = this;
        this.$confirm('您确定要删除该学习记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/kt/ktStudyRecord/del.htm?'+this.$qs.stringify({id:id,state:0}),{
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.$message({
                message: data.message,
                type: 'success'
              });
              this.getList();
            } else {
              this.$message.error(data.message);
            }
          })
        }).catch(() => {});
      }
    },
    components: {},
    created: function() {
      this.getList();
    }
  }
</script>


<style>
  .myhistor-cont {
    text-align: left;
    padding: 20px;
  }

  .myhistorEvery {
    /* width: 879px; */
    height: 133px;
    opacity: 1;
    border: 1px solid #efefef;
    border-radius: 4px;
    margin: 20px auto 0;
    padding: 20px;
    display: flex;
    align-items: center;
    transition: all 0.3s linear;
    justify-content: space-between;
  }

  .myhistorEvery:hover {
    border: 1px solid #0071ba;
    border-radius: 4px;
  }

  .myhistorEvery-img {
    width: 201px;
    height: 121px;
    opacity: 1;
    border-radius: 6px;
  }

  .myhistorEvery-img img {
    width: 201px;
    height: 121px;
    opacity: 1;
    border-radius: 6px;
  }

  .myhistorEvery-nr {
    margin-left: 20px;
    text-align: left;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 118px;
  }

  .histor-eve-tit {
    /* width: 496px; */
    opacity: 1;
    font-size: 18px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 25px;
  }

  .histor-eve-tit span {
    width: 38px;
    height: 18px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    color: #fff;
    font-size: 13px;
    display: inline-block;
    line-height: 18px;
    text-align: center;
    margin-right: 5px;
  }

  .histor-eve-yxq {
    opacity: 1;
    font-size: 13px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 18px;
    margin: 7px 0;
  }

  .histor-eve-progress {
    /* width: 484px; */
    height: 32px;
    opacity: 1;
    background: linear-gradient(275deg, #e6f2ff 3%, #e0f5ff 96%);
    border-radius: 4px;
    line-height: 32px;
    color: #333333;
    font-size: 13px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
  }

  .histor-bot-span2 {
    opacity: 1;
    font-size: 13px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: right;
    color: #0071ba;
    line-height: 32px;
    cursor: pointer;
  }

  .el-timeline-item__tail {
    border-left: 2px dashed #e4e7ed;
  }
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/Historical.vue